import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
import EmailSubscriptionCenterModal from './EmailSubscriptionCenterModal.jsx'

function ModalButton(props) {
  const [showModal, setShowModal] = useState(false)

  const closeMe = () => {
    setShowModal(false)
    window.location.reload()
  }

  const handleStaticSubscribeClicked = async (event) => {
    event.persist()
    setShowModal(true)
    return null
  }

  const getStaticSubscribeButton = () => {
    return (
      <button
        onClick={handleStaticSubscribeClicked}
        id="static-cesc-subscribe-button"
        className="Button Button--tertiary u-inlineBlock u-paddingHoriz4gu"
        data-analytics="cesc-subscribe-link"
        data-qa-automation="subscribe-button"
      >
        <span className="Icon--material u-textColorBrand u-block u-marginCenter u-textSizeMsrp4">
          mail_outline
        </span>
        Subscribe
      </button>
    )
  }

  const getStaticSubscribedButton = () => {
    return (
      <button
        onClick={handleStaticSubscribeClicked}
        id="static-cesc-subscribed-button"
        className="Button Button--tertiary u-inlineBlock u-paddingHoriz4gu"
        data-analytics="cesc-subscribe-link"
        data-qa-automation="subscribe-button"
      >
        <span className="Icon--material u-textColorBrand u-block u-marginCenter u-textSizeMsrp4 u-posRelative">
          mail_outline
          <span className="Icon--material u-posAbsolute u-textColorWhite u-bgColorConfirm u-textSizeMsrm2 u-textBold Subscribed-icon--stacked">
            check
          </span>
        </span>
        Subscribed
      </button>
    )
  }

  const isAnythingSubscribed = () => {
    return (
      (props.subscriptions && props.subscriptions.find((doc) => doc.checked)) ||
      (props.docs && props.docs.find((doc) => doc.selected))
    )
  }

  const getSubscriptions = () => {
    let subs = null
    if (props.subscriptions) {
      subs = JSON.parse(JSON.stringify(props.subscriptions))
      if (!isLoggedIntoSubscriptionCenter()) {
        subs[0].checked = true
      }
    }

    return subs
  }

  const getDocs = () => {
    if (props.docs) {
      const subs = JSON.parse(JSON.stringify(props.docs))
      if (!isLoggedIntoSubscriptionCenter()) {
        subs[0].selected = true
      }
      return subs
    }
    return []
  }

  return (
    <>
      {showModal && (
        <EmailSubscriptionCenterModal
          subscriptions={getSubscriptions()}
          docs={getDocs()}
          isLoggedIn={isLoggedIntoSubscriptionCenter()}
          handleCloseModalClick={closeMe}
        />
      )}

      {isAnythingSubscribed()
        ? getStaticSubscribedButton()
        : getStaticSubscribeButton()}
    </>
  )
}

ModalButton.propTypes = {
  subscriptions: PropTypes.array,
}

export default ModalButton
